"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireDefault(require("react"));
var _text = require("@mmc/text");
var _commonCta = require("@mmc/common-cta");
var _commonRichText = require("@mmc/common-rich-text");
var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));
var _reactRedux = require("react-redux");
var _commonI18n = require("@mmc/common-i18n");
var _configuratorLargeSummary = _interopRequireDefault(require("../styles/configurator-large-summary.css"));
var _configuratorLargeSummary2 = require("./configurator-large-summary.props/configurator-large-summary.propTypes");
var _shareLink = _interopRequireDefault(require("./share-link"));
var dataUtils = new _mmcDataUtilities["default"]();
var handleNestedProp = dataUtils.handleNestedProp;
var ConfigurationTextBlock = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(ConfigurationTextBlock, _React$Component);
  function ConfigurationTextBlock() {
    return _React$Component.apply(this, arguments) || this;
  }
  var _proto = ConfigurationTextBlock.prototype;
  _proto.renderPreferenceItem = function renderPreferenceItem(item, i) {
    var inputsAndOptions = this.props.theme.inputsAndOptions;
    if (item) {
      if (item.code) {
        return /*#__PURE__*/_react["default"].createElement("li", {
          className: inputsAndOptions,
          key: handleNestedProp(item, 'item.id') + "-" + i
        }, handleNestedProp(item, 'item.label'));
      }
      return [];
    }
    return [];
  };
  _proto.render = function render() {
    var _this = this;
    var _this$props = this.props,
      preferences = _this$props.preferences,
      changeEvent = _this$props.changeEvent,
      config = _this$props.config,
      rootUrl = _this$props.rootUrl,
      configuratorCode = _this$props.configuratorCode,
      copyText = _this$props.copyText,
      direction = _this$props.direction,
      shareDescription = _this$props.shareDescription,
      theme = _this$props.theme,
      addPriceDisclaimer = _this$props.addPriceDisclaimer,
      priceDisclaimerId = _this$props.priceDisclaimerId,
      disclaimerData = _this$props.disclaimerData;
    var propsObj = this.props;
    var market = handleNestedProp(config, 'config.market').toLowerCase();
    var descriptionIsMissing = handleNestedProp(propsObj, 'propsObj.model.description') === ' ' || handleNestedProp(propsObj, 'propsObj.model.description') === null || handleNestedProp(propsObj, 'propsObj.model.description') === '';
    var totalPriceValue = handleNestedProp(propsObj, 'propsObj.price.value');
    var zeroMessage = handleNestedProp(propsObj, 'propsObj.model.price.zeroMessage');
    var modelPriceValue = handleNestedProp(propsObj, 'propsObj.model.price.value');
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: theme['col-xs-12'] + " " + theme['col-sm-5'] + " " + (direction !== 'rtl' ? theme['col-sm-offset-1'] : _configuratorLargeSummary["default"].rtlSpace),
      dir: direction
    }, /*#__PURE__*/_react["default"].createElement("p", {
      className: theme.labelMedium + " " + theme.marginBottom20
    }, handleNestedProp(propsObj, 'propsObj.title')), /*#__PURE__*/_react["default"].createElement("div", {
      className: _configuratorLargeSummary["default"].content
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _configuratorLargeSummary["default"].headline + " " + theme.marginBottom5
    }, /*#__PURE__*/_react["default"].createElement("h3", {
      className: theme.headingThree + " " + _configuratorLargeSummary["default"].modelName
    }, handleNestedProp(propsObj, 'propsObj.vehicle.name'), ' ', handleNestedProp(propsObj, 'propsObj.model.name'))), /*#__PURE__*/_react["default"].createElement("p", {
      className: theme.headingSix + " " + theme.marginBottom40
    }, market === 'pt' ? '*' : '', /*#__PURE__*/_react["default"].createElement(_commonI18n.CommonI18N, {
      format: "price",
      returnZero: true,
      options: {
        value: modelPriceValue === 0 ? modelPriceValue : totalPriceValue,
        currency: handleNestedProp(config, 'config.currencyFormat'),
        locale: handleNestedProp(config, 'config.localeCode'),
        zeroMessage: zeroMessage
      },
      addPriceDisclaimer: addPriceDisclaimer,
      priceDisclaimerId: priceDisclaimerId,
      disclaimerData: disclaimerData
    })), !descriptionIsMissing ? /*#__PURE__*/_react["default"].createElement("div", {
      className: theme.bodyCopy + " " + theme.marginBottom20 + " " + _configuratorLargeSummary["default"].richTextHeadlines
    }, /*#__PURE__*/_react["default"].createElement(_commonRichText.CommonRichText, {
      theme: theme,
      format: null,
      html: handleNestedProp(propsObj, 'propsObj.model.description')
    })) : '', /*#__PURE__*/_react["default"].createElement("ul", {
      className: theme.row + " " + _configuratorLargeSummary["default"].preferences + " " + theme.marginBottom30 + " " + theme.BodyCopyBold
    }, preferences && preferences.map(function (item, i) {
      return _this.renderPreferenceItem(item, i);
    })), rootUrl && configuratorCode && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("p", {
      className: theme.bodyCopy + " " + _configuratorLargeSummary["default"].shareDescription
    }, shareDescription), /*#__PURE__*/_react["default"].createElement(_shareLink["default"], {
      rootUrl: rootUrl,
      configuratorCode: configuratorCode,
      copyText: copyText,
      theme: theme
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: theme.marginTop20 + " " + theme.marginBottom20
    }, /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
      data: {
        priority: 'low',
        label: handleNestedProp(propsObj, 'propsObj.changeText')
      },
      theme: theme,
      clickEvent: changeEvent,
      classes: [_configuratorLargeSummary["default"].changeLink]
    }))));
  };
  return ConfigurationTextBlock;
}(_react["default"].Component);
ConfigurationTextBlock.displayName = 'ConfigurationTextBlock';
var mapStateToProps = function mapStateToProps(state) {
  return {
    config: state.Config
  };
};
var _default = (0, _reactRedux.connect)(mapStateToProps, function (dispatch) {
  return {
    dispatch: dispatch
  };
})(ConfigurationTextBlock);
exports["default"] = _default;